import styled from 'styled-components';
import { Button } from '@lux/buttons';
import { FunctionColor, Spacer } from '@lux/core';

export const AllCampaignCardWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 100%;
    overflow: hidden;
`;

export const AllCampaignImage = styled.img`
    position: absolute;
    max-width: 100%;
    width: auto;
    height: auto;
`;

export const AllCampaignImageOverlay = styled.span`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
`;

export const AllCampaignText = styled(Button)`
    z-index: 2;
    line-height: 21px;
    width: min-content;
    max-width: 100%;
    margin: 0 ${Spacer.S};
    text-align: center;
    color: ${FunctionColor.function0};
    &:after {
        background-color: ${FunctionColor.function0};
    }
`;
